import { api } from "@/lib/api";
import {
  CreateGuide,
  Guide,
  GuideDtoSchema,
  mapCreateGuideToDto,
  mapGuideFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getGuidesQueryOptions } from "./get.hooks";

export function useCreateGuide(opts?: {
  onSuccess?: (guide: Guide) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (guide: CreateGuide) => {
      const dto = mapCreateGuideToDto(guide);
      const result = await api.post("/api/guides", dto, GuideDtoSchema);
      return mapGuideFromDto(result);
    },
    onSuccess: (guide) => {
      queryClient.setQueryData(getGuidesQueryOptions.queryKey, (old) => [
        ...(old || []),
        guide,
      ]);
      toast({
        title: "toast.guideCreated",
        variant: "success",
      });
      opts?.onSuccess?.(guide);
    },
    onError: () => {
      toast({
        title: "toast.createGuideError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
